import { CloudPlatform, normalizePlatform } from '@/pages/admin/settings/cloud_provider/CloudProviderCategory';
import { CloudProviderT } from '@/pages/admin/settings/cloud_provider/types';

export const awsRegionNameMap: Record<string, string> = {
  'us-east-1': 'US East (N. Virginia)',
  'us-east-2': 'US East (Ohio)',
  'us-west-1': 'US West (N. California)',
  'us-west-2': 'US West (Oregon)',
  'eu-central-1': 'Europe (Frankfurt)',
  'eu-west-1': 'Europe (Ireland)',
  'eu-west-2': 'Europe (London)',
  'eu-south-1': 'Europe (Milan)',
  'eu-west-3': 'Europe (Paris)',
  'eu-south-2': 'Europe (Spain)',
  'eu-north-1': 'Europe (Stockholm)',
  'eu-central-2': 'Europe (Zurich)',
  'sa-east-1': 'South America (São Paulo)',
  'ca-central-1': 'Canada (Central)',
  'ca-west-1': 'Canada West (Calgary)',
  'ap-east-1': 'Asia Pacific (Hong Kong)',
  'ap-south-2': 'Asia Pacific (Hyderabad)',
  'ap-southeast-3': 'Asia Pacific (Jakarta)',
  'ap-southeast-4': 'Asia Pacific (Melbourne)',
  'ap-south-1': 'Asia Pacific (Mumbai)',
  'ap-northeast-3': 'Asia Pacific (Osaka)',
  'ap-northeast-2': 'Asia Pacific (Seoul)',
  'ap-southeast-1': 'Asia Pacific (Singapore)',
  'ap-southeast-2': 'Asia Pacific (Sydney)',
  'ap-northeast-1': 'Asia Pacific (Tokyo)',
  'il-central-1': 'Israel (Tel Aviv)',
  'me-south-1': 'Middle East (Bahrain)',
  'me-central-1': 'Middle East (UAE)',
  'us-gov-east-1': 'AWS GovCloud (US-East)',
  'us-gov-west-1': 'AWS GovCloud (US-West)',
  'af-south-1': 'Africa (Cape Town)',
};

// Formats a region as "<friendly name> · <region code>", e.g. "US East (Ohio) · us-east-2".
// Falls back to the bare region code when no friendly name is known.
export function formatRegionLabel(region: string, description?: string) {
  const friendlyName = awsRegionNameMap[region] || description;
  if (!friendlyName || friendlyName === region) {
    return region;
  }
  return `${friendlyName} · ${region}`;
}

export function getRegionName(cp: Pick<CloudProviderT, 'platform' | 'region'> | null) {
  if (!cp) {
    return '';
  }

  if (normalizePlatform(cp.platform) === CloudPlatform.AWS) {
    return formatRegionLabel(cp.region);
  }

  return cp.region;
}
